export var ImagePathConfig;
(function (ImagePathConfig) {
    let ImageView;
    (function (ImageView) {
        ImageView.loading = '/img/pacman-iijike.png';
    })(ImageView = ImagePathConfig.ImageView || (ImagePathConfig.ImageView = {}));
    let ConfirmMessage;
    (function (ConfirmMessage) {
        ConfirmMessage.information = '/img/pacman_002.png';
        ConfirmMessage.warning = '/img/pacman-iclyde.png';
        ConfirmMessage.danger = '/img/pacman-iblinky.png';
    })(ConfirmMessage = ImagePathConfig.ConfirmMessage || (ImagePathConfig.ConfirmMessage = {}));
    let CornerMessage;
    (function (CornerMessage) {
        CornerMessage.icon = '/img/pacman_001.png';
    })(CornerMessage = ImagePathConfig.CornerMessage || (ImagePathConfig.CornerMessage = {}));
    let Loading;
    (function (Loading) {
        Loading.imageArray = [
            "/img/pacman-iblinky.png",
            "/img/pacman-iclyde.png",
            "/img/pacman-inky.png",
            "/img/pacman-pinky.png",
            "/img/pacman.png",
        ];
    })(Loading = ImagePathConfig.Loading || (ImagePathConfig.Loading = {}));
    let SorryMessage;
    (function (SorryMessage) {
        SorryMessage.icon = '/img/pacman-iijike.png';
    })(SorryMessage = ImagePathConfig.SorryMessage || (ImagePathConfig.SorryMessage = {}));
})(ImagePathConfig || (ImagePathConfig = {}));
